<div class="incoming-referral-card" [class.stale]="isStale()" (click)="onCardClick()">
  <!-- Patient Initials Avatar -->
  <div class="patient-avatar">
    <span class="initials">{{ patientInitials() }}</span>
  </div>

  <!-- Main Content -->
  <div class="card-content">
    <!-- Header Row: Patient Name + Status -->
    <div class="card-header">
      <div class="patient-info">
        <span class="patient-name">{{ patientName() }}</span>
        <span class="patient-demographics">
          @if (patientAge(); as age) {
            {{ age }}
          }
          @if (patientAge() && patientGender()) {
            <span class="separator">·</span>
          }
          @if (patientGender(); as gender) {
            {{ gender }}
          }
        </span>
      </div>
      <mat-chip [class.stale-chip]="isStale()" class="status-chip" highlighted>
        {{ statusLabel() }}
      </mat-chip>
    </div>

    <!-- From Doctor Row -->
    <div class="from-row">
      <mat-icon class="from-icon">mail</mat-icon>
      <span class="from-label">From</span>
      <span class="doctor-name">{{ sendingDoctorName() }}</span>
      @if (sendingDoctorAvatarUrl()) {
        <img [src]="sendingDoctorAvatarUrl()" class="doctor-avatar" alt="Doctor Avatar">
      }
    </div>

    <!-- Date Row -->
    <div class="date-row">
      <mat-icon class="date-icon">schedule</mat-icon>
      <span class="date-text">{{ formatDate(referral().createdDate) }}</span>
    </div>

    <!-- Clinical Indicators Row -->
    @if (hasAllergies() || hasMedications() || hasProblems()) {
      <div class="clinical-row">
        @if (hasAllergies()) {
          <div class="clinical-badge allergy" matTooltip="Patient has allergies">
            <mat-icon>warning</mat-icon>
            <span>Allergies</span>
          </div>
        }
        @if (hasMedications()) {
          <div class="clinical-badge medications" matTooltip="Patient has medications">
            <mat-icon>medication</mat-icon>
            <span>Meds</span>
          </div>
        }
        @if (hasProblems()) {
          <div class="clinical-badge problems" matTooltip="Patient has medical problems">
            <mat-icon>description</mat-icon>
            <span>Problems</span>
          </div>
        }
      </div>
    }
  </div>
</div>
